export default __webpack_public_path__ + "static/media/Alcohol.a2569b25.svg";